import React from 'react';
import { X, Download } from 'lucide-react';
import { useInstallPrompt } from '../../hooks/useInstallPrompt';

export function InstallBanner() {
  const { isInstallable, install, dismiss } = useInstallPrompt();

  // Stage 17 P7 — never show during signup/onboarding/upload/chat flows
  // (they competed with core actions). Safe-list of paths where install is OK.
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const hiddenOn = ['/register', '/login', '/onboarding', '/welcome', '/documents', '/upload', '/chat', '/billing', '/reset-password', '/forgot-password'];
  const suppressedByRoute = hiddenOn.some((p) => path === p || path.startsWith(p + '/'));

  if (!isInstallable || suppressedByRoute) return null;

  return (
    <div
      data-testid="install-banner"
      className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:w-[340px] z-[60] bg-white rounded-2xl shadow-xl border border-gray-100 p-4 flex items-center gap-3 animate-in slide-in-from-bottom-4"
    >
      <div className="w-10 h-10 rounded-xl bg-[#235347]/10 flex items-center justify-center flex-shrink-0">
        <Download className="w-5 h-5 text-[#235347]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900">Install Kindra</p>
        <p className="text-xs text-gray-500">Add to home screen for quick access</p>
      </div>
      <button
        onClick={install}
        data-testid="install-banner-install"
        className="px-3 py-1.5 text-xs font-medium text-white bg-[#235347] rounded-lg hover:bg-[#1a3f36] transition-colors flex-shrink-0"
      >
        Install
      </button>
      <button
        onClick={dismiss}
        data-testid="install-banner-dismiss"
        className="p-1 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
